// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotificationModal_wrapper__qNK8H","title":"NotificationModal_title__L3nj0","button":"NotificationModal_button__129J4","date":"NotificationModal_date__1YyHp"};